
import { Link } from 'react-router-dom';

const CTASection = () => {
  return (
    <section className="relative bg-charcoal-dark py-32 overflow-hidden">
      {/* Subtle Radial Accent */}
      <div 
        className="absolute inset-0 opacity-30"
        style={{
          background: 'radial-gradient(ellipse at center, rgba(168, 144, 120, 0.1) 0%, transparent 60%)',
        }}
      ></div>

      <div className="max-w-[1600px] mx-auto px-8 relative z-10">
        {/* Main Content */}
        <div className="text-center space-y-10">
          {/* Title */}
          <div className="space-y-3">
            <h2 className="text-5xl lg:text-6xl font-light text-white leading-tight">
              Ready to Transform
            </h2>
            <h2 
              className="text-5xl lg:text-6xl font-semibold leading-tight"
              style={{
                background: 'linear-gradient(90deg, #7A6A5A 0%, #A89078 20%, #C4B8A8 40%, #D8CCC0 50%, #C4B8A8 60%, #A89078 80%, #7A6A5A 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
              }}
            >
              Your Operations?
            </h2>
          </div>

          {/* Subtitle */}
          <p className="text-lg text-gray-500 max-w-2xl mx-auto">
            Schedule a confidential consultation with our executive team
          </p>

          {/* CTA Button */}
          <Link
            to="/contact"
            className="inline-flex items-center gap-3 text-white px-12 py-4 rounded-full text-base font-semibold transition-all duration-300 whitespace-nowrap border border-copper/50 hover:bg-copper/10"
            style={{
              background: 'linear-gradient(90deg, rgba(122, 106, 90, 0.2) 0%, rgba(168, 144, 120, 0.3) 50%, rgba(122, 106, 90, 0.2) 100%)',
            }}
          >
            Request Consultation
            <i className="ri-arrow-right-line text-lg"></i>
          </Link>
        </div>

        {/* U.S. Entities Strip */}
        <div className="mt-20 pt-12 border-t border-gray-800">
          <div className="flex items-center justify-center gap-12 flex-wrap">
            <div className="text-center">
              <p className="text-white font-medium mb-1">MACAR Enterprises Corp.</p>
              <p className="text-xs text-gray-600">North American Division of MACGOC</p>
            </div>
            <div className="w-px h-10 bg-gray-800 hidden md:block"></div>
            <div className="text-center">
              <p className="text-white font-medium mb-1">North American Healthcare Group Corp.</p>
              <p className="text-xs text-gray-600">Healthcare Division of MACAR Enterprises</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
